import React, {useState, useEffect} from 'react';
import {Container, Grid, Backdrop, Typography, CircularProgress, ListItem, ListItemIcon, ListItemText, Button} from '@material-ui/core/';
import {ContactPhone, NavigateNext, Send} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import {AccountCircle, Email, Filter1, VpnKey } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import Table from 'components/Table';
import { stateRestart } from '../../../../../../../../helpers/stateRestart';
import MensajeAlerta from 'components/ResponseElement'
import { Alert } from '@material-ui/lab';
import LoadingSpinner from 'components/LoadingSpinner';
import TablaHistorialDeRegistroDeContactos from '../TablaDeHistorialDeRegistroDeContactos'
import { showMessageError, showMessagePersonalizedToast } from 'services/SweetAlert';

function AgregarRegistroDeContacto(props) {
    let history = useHistory();
    const classes = useStyles(),
        [cargandoDatos, setCargandoDatos] = useState(false),
        [arrayMetodoContacto, setArrayMetodoContacto] = useState([
            {id: 0, name:'Número Teléfonico'},
            {id: 1, name:'Correo Electrónico'},
            {id: 2, name:'Presencial'},
        ]),
        [arrayEstadoDeRespuesta, setArrayEstadoDeRespuesta] = useState([
            {id: 0, name:'NO'},
            {id: 1, name:'SI'},
        ]),
        [loadingCargarTabla, setLoadingCargarTabla] = useState(false),
        [data, setData] = useState ([]),
        [listarDatosTabla, setListarDatosTabla] = useState ([]),
        [limiteDeRegistroDeContactos, setLimiteDeRegistroDeContactos] = useState(false),
        [agregarFormaDeContacto, setAgregarFormaDeContacto] = useState('');

    const setearFormaContacto = () =>{
        if(elements.metodoContacto.value.id === 0) elements.formaContacto.value = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.telefono;
        else if(elements.metodoContacto.value.id === 1) elements.formaContacto.value = props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.email;
        else if(elements.metodoContacto.value.id === 2) elements.formaContacto.value = 'Delegación/Sub-delegación';

        if(elements.metodoContacto.value?.name === '') {
            elements.formaContacto.value = '';
        }
    }        

    const [elements,setElements] = useState({
        metodoContacto: {  idelement: "metodoContacto",  value:'', label: "Método de Contacto *", pattern:"^[0-9][0-9]*$", validators: ['required'], errorMessages:['Seleccione Método de Contacto'], isError:false, elementType:'autocompleteV2', list: arrayMetodoContacto, handler: setearFormaContacto},
        formaContacto: { idelement: "formaContacto",  value:'', label: "Forma de Contacto *", pattern:"^([\\w_][\\w_ -.\"\'ÑñáéíóúÁÉÍÓÚ@/]*[\\w_.\"\'ÑñáéíóúÁÉÍÓÚ@/]){1,150}$", validators: ['required'], errorMessages:['Sin espacios al inicio y final'], isError:false, elementType:'input' },
        fechaRegistro: { idelement: "fechaRegistro", value: new Date(), label: "Fecha de Registro *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required'], errorMessages:['Ingrese fecha de Registro'], isError:false, elementType:'date' },
        // horaRegistro: { idelement: "horaRegistro",  value: '', label: "Hora de Registro *", pattern:"^([\\w_][\\w_ -.:\"\'ÑñáéíóúÁÉÍÓÚ]*[\\w_.:\"\'ÑñáéíóúÁÉÍÓÚ]){1,150}$", validators: ['required'], errorMessages:['Ingrese Hora de Registro'], isError:false, elementType:'input' },
        // horaRegistro: { idelement: "horaRegistro",  value:new Date(), label: "Hora de Registro *", pattern:"^([\\w_][\\w_ -.:\"\'ÑñáéíóúÁÉÍÓÚ]*[\\w_.:\"\'ÑñáéíóúÁÉÍÓÚ]){1,150}$", validators: ['required'], errorMessages:['Ingrese Hora de Registro'], isError:false, elementType:'time' },
        observacion: { idelement: "observacion",  value:'', label: "Observación *", pattern:"^[\\w1-9 _ÑñáéíóúÁÉÍÓÚ@/.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", validators: ['required'], errorMessages:['Observación requerido, Máximo 50 carácteres'], isError:false, elementType:'input' },
        estadoRespuesta: {  idelement: "estadoRespuesta",  value:'', label: "Estado de Respuesta ¿Respondio? *", pattern:"^[0-9][0-9]*$", validators: ['required'], errorMessages:['Seleccione Estado de Respuesta'], isError:false, elementType:'autocompleteV2', list: arrayEstadoDeRespuesta},
    });

    const AgregarRegistroALATabla= async()=>{
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            setLoadingCargarTabla(true)
            let saveData ={idSolicitud: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.idSolicitud, metodoDeContacto: elements.metodoContacto.value.id, formaDeContacto: elements.formaContacto.value,
                fechaDeRegistro: elements.fechaRegistro.value, observaciones: elements.observacion.value, estadoDeRespuesta: elements.estadoRespuesta.value.id,
            }
            try {
                let response = await ApiServices.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos.create(saveData)
                if(response.error!==null){
                    showMessagePersonalizedToast('error', '¡Oops! ' +response.error.message)
                }
                else{
                    showList()
                    showMessagePersonalizedToast('success', "BIEN! Registro de Contacto agregado con éxito.")
                    stateRestart(elements)
                }
            } catch (error) {
                if(error.status===404) {
                    showMessagePersonalizedToast('error', 'Oops!. Falla del Sistema. póngase en contacto con el Administrador sí este mensaje persiste.')
                }else {
                    showMessagePersonalizedToast('error', 'Oops!. Intente de nuevo. póngase en contacto con el Administrador sí este mensaje persiste.')
                }                
            }           
            setLoadingCargarTabla(false)   
        }
    };

    const Cerrar=()=>{
        props.handleClose()
    };    

    const showList = async ()=>{
        setLoadingCargarTabla(true)
        try{

            const hasPermission = await ApiServices.userSecurity.hasPermission('registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos','list');    
            if (hasPermission.error){
                setLoadingCargarTabla(true)
            }else{
                ApiServices.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos.searchCriteria.clear();
                ApiServices.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos.searchCriteria.setOperator("and");
                ApiServices.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos.searchCriteria.addEquals("idSolicitud", props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.idSolicitud);  
                let response =  await ApiServices.registrosDeContactoParaValidarDatosDeSolicitudesConCiudadanos.listRegisterCriteria();
                setListarDatosTabla(response.data)
            }
        }catch(exception){
            if(exception.status===404) {
                showMessagePersonalizedToast('error', '¡Oops! ' +'Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }else {
                showMessagePersonalizedToast('error', '¡Oops! ' +'Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }
        }
        setLoadingCargarTabla(false)
    }

    useEffect(() => {
        if(listarDatosTabla.length === 3) setLimiteDeRegistroDeContactos(true);
        else setLimiteDeRegistroDeContactos(false);
    },[listarDatosTabla])    

    useEffect(() => {
        showList()
    },[])    

    return (
        <div className={classes.root}>
            {
                (loadingCargarTabla) ? <LoadingSpinner open={loadingCargarTabla} /> : ''
            }
            <Container  className={classes.colorComponente}>
                <Grid container >
                    {limiteDeRegistroDeContactos ? (
                        <Grid className={classes.AlignAlerta} item xs={12}>
                            <Alert  variant="outlined" severity="warning">
                                ¡Oops!, Ha llegado al limite de Registro de Contacto.
                            </Alert>
                        </Grid>                                                               
                    ):''}                                        
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body1" color="textPrimary"> <strong>Formulario de Registro de Contacto</strong></Typography>
                    </Grid>
                    <Grid className={classes.AlignTable} item xs={12}>
                        <Form   elements= {elements}  BotonCerrar={Cerrar} BotonPersonlizado={AgregarRegistroALATabla} disabledBotonPersonalizado={limiteDeRegistroDeContactos}
                            disabled={limiteDeRegistroDeContactos} TituloBotonPersonalizado={'Agregar Registro'}
                        />
                    </Grid>                                                           
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </Container><br/>
            <Container  className={classes.colorComponente}>
                <Grid container >
                    <Grid className={classes.AlignTable} item xs={12}>
                        <TablaHistorialDeRegistroDeContactos listarDatosTabla={listarDatosTabla} showList={showList} loadingCargarTabla={loadingCargarTabla}
                            idSolicitud={props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.idSolicitud}
                        />
                    </Grid>                                       
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </Container><br/>
            <Backdrop className={classes.backdrop} open={cargandoDatos} onClick={cargandoDatos}>
                <CircularProgress color="inherit" /> Cargando datos ...
            </Backdrop>              
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(AgregarRegistroDeContacto);